/*
 *  I02CHOIXENERCHAUFI18n.js
 *
 *  Created by Sébastien Hecart on 2018-03-10 14:25:48 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I02CHOIXENERCHAUF_SECTION_0_TITLE: 'Consommation annuelle',
  I02CHOIXENERCHAUF_SECTION_0BIS_TITLE: 'Installation de chauffage existante',
  I02CHOIXENERCHAUF_I04DIMPUISSCHAUD: 'Selon la surface habitable',
  I02CHOIXENERCHAUF_rendementProduction_uuid: "Type de l'ancienne production",
  I02CHOIXENERCHAUF_in_consommation: 'Consommation',
  I02CHOIXENERCHAUF_in_rendementProduction1: 'Rendement ancienne production',
  I02CHOIXENERCHAUF_in_rendementProduction2: 'Rendement nouvelle production',
  I02CHOIXENERCHAUF_in_ancienneFactureEnergie: "Anciennes factures d'énergies",
  I02CHOIXENERCHAUF_SECTION_1_TITLE: 'Type nouvelle production',
  I02CHOIXENERCHAUF_rendementProduction_uuid2: 'Type de la nouvelle production',
  I02CHOIXENERCHAUF_res_consoAnnuelEstime: 'Nouvelle facture estimée',
  I02CHOIXENERCHAUF_res_exProdCO2: 'Production CO2 ancienne installation',
  I02CHOIXENERCHAUF_res_newProdCO2: 'Production CO2 nouvelle installation',
  I02CHOIXENERCHAUF_res_gainCO2: 'Gain de CO2 par an',
  I02CHOIXENERCHAUF_res_gainCO2negatif: 'Remplacement non écologique',
  I02CHOIXENERCHAUF_SECTION_2_TITLE: 'Bilan économique et écologique',
  I02CHOIXENERCHAUF_in_coutInstallDevis: 'Coût installation / devis',
  I02CHOIXENERCHAUF_in_aidecredit: "Aide et crédit d'impôt (TOTAL)",
  I02CHOIXENERCHAUF_in_surcout: "Surcoût du contrat d'entretien par an",
  I02CHOIXENERCHAUF_res_temptri: 'Retour sur investissement',
  I02CHOIXENERCHAUF_res_temptrinon: 'Remplacement non rentable',
  I02CHOIXENERCHAUF_in_coutNewEnergie: 'Coût de la nouvelle energie',
  I02CHOIXENERCHAUF_in_emiCO2new: 'Emission de CO2 nouvelle installation',
  I02CHOIXENERCHAUF_in_hausseAncien: 'Hausse/an ancienne energie',
  I02CHOIXENERCHAUF_in_hausseNew: 'Hausse/an nouvelle energie',
  I02CHOIXENERCHAUF_MAIL_TITLE0: 'Installation de chauffage existante'
}
